import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Clock, Shield, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CountryConversionSectionProps {
  countryName: string;
  totalCities: number;
  countrySlug: string;
}

const CountryConversionSection = ({ countryName, totalCities, countrySlug }: CountryConversionSectionProps) => {
  return (
    <section className="bg-gradient-to-br from-brand-blue-50 to-brand-blue-100 py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-brand-gray-900 mb-6">
            Why Choose Mental Health Professionals in {countryName}?
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="w-12 h-12 bg-brand-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="h-6 w-6 text-brand-blue-600" />
              </div>
              <h3 className="font-semibold text-brand-gray-900 mb-2">Extensive Network</h3>
              <p className="text-sm text-brand-gray-600">{totalCities}+ cities with qualified professionals</p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="w-12 h-12 bg-brand-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="h-6 w-6 text-brand-green-600" />
              </div>
              <h3 className="font-semibold text-brand-gray-900 mb-2">Licensed & Verified</h3>
              <p className="text-sm text-brand-gray-600">All professionals are certified and verified</p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="w-12 h-12 bg-brand-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="h-6 w-6 text-brand-purple-600" />
              </div>
              <h3 className="font-semibold text-brand-gray-900 mb-2">Flexible Scheduling</h3>
              <p className="text-sm text-brand-gray-600">Online and in-person appointments available</p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="w-12 h-12 bg-brand-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Star className="h-6 w-6 text-brand-orange-600" />
              </div>
              <h3 className="font-semibold text-brand-gray-900 mb-2">Proven Results</h3>
              <p className="text-sm text-brand-gray-600">Thousands of successful therapy outcomes</p>
            </div>
          </div>
          
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-brand-gray-900 mb-4">
              Start Your Mental Health Journey Today
            </h3>
            <p className="text-brand-gray-600 mb-6 max-w-2xl mx-auto">
              Connect with licensed mental health professionals in {countryName}. 
              Whether you prefer online sessions or in-person meetings, find the right therapist for your needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="bg-brand-blue-600 hover:bg-brand-blue-700">
                <Link to="/find">Find a Therapist Now</Link>
              </Button>
              <Button asChild variant="outline" size="lg">
                <Link to="/online-therapy">Learn About Online Therapy</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CountryConversionSection;